import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import Storage from 'vue-ls'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VuetifyDialog from 'vuetify-dialog'
import 'vuetify-dialog/dist/vuetify-dialog.css'

import Croppa from 'vue-croppa'

Vue.use(Croppa)

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
})

const toastOptions = {
}
Vue.use(Toast, toastOptions)

const options = {
  namespace: 'vuejs__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}
Vue.use(Storage, options)

Vue.use(CKEditor)

Vue.config.productionTip = false

function sleep (milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

Vue.prototype.$store = store
Vue.prototype.$sleep = sleep

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
